<div class="toast__content">
  <h4 class="toast__title" *ngIf="title">{{ title }}</h4>
  <p class="toast__message" *ngIf="toast.message">{{ toast.message }}</p>
  <div class="toast__message" *ngIf="toast.content?.body" [internalInnerHtml]="toast.content.body"></div>
</div>
<div class="toast__cta" *ngIf="toast.buttons && toast.buttons.length">
  <div class="button__group">
    <a
      class="button"
      *ngFor="let button of toast.buttons"
      (click)="onButtonClick(button)"
      [ngClass]="button.buttonClass ? button.buttonClass : 'button--secondary'"
      [airButtonLoading]="!!button.isLoading"
    >
      <span>{{ button.text }}</span>
    </a>
  </div>
</div>
